import { GET_REGLAS_AUTORIZADAS_LIST } from "./ReglasAutorizadasAction";

let initialState = {
    getReglasAutorizadasList:           false,
    errorReglasAutorizadasList:         false,
};

const ReglasAutorizadasReducer = (state = initialState, action) => {
    //console.log(action.type);

    switch (action.type) {

        case GET_REGLAS_AUTORIZADAS_LIST:
            return {
                ...state,
                getReglasAutorizadasList: action.payload.data,
                errorReglasAutorizadasList: action.payload.errorMessage,
            };

        default:
            return state;


    }//END SWITCH

}//END FUNCTION

export default ReglasAutorizadasReducer;